const FORGET_PASSWORD = {
  CARD_TITLE: "بازیابی رمز عبور",
  CARD_SUB_TITLE:
    "آدرس ایمیل خود را وارد کنید، ما دستورالعمل بازیابی را برای شما ایمیل می‌کنیم.",
  EMAIL_PH: "ایمیل",
  SEND: "ارسال",
  BACK_TO_LOGIN: "بازگشت یه صفحه ورود",
};

export default FORGET_PASSWORD;
